import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Tooltip,
  Modal,
  Row,
  Col,
  Typography,
  Button,
  Descriptions,
  Form,
  Input,
  Select,
  notification,
} from "antd";
import { postReq } from "../api";
import { toastNotification } from "../utils/toasthelper";
import useUserDetails from "../utils/useUserDetails";
const { Title } = Typography;
const { Option } = Select;

const Client = () => {
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [isSearch, setIsSearch] = useState(true);
  const [requiredTech, setRequiredTech] = useState([]);
  const [editData, setEditData] = useState(null);
  const columns = [
    {
      title: "Name",
      dataIndex: "clientCompanyName",
      key: "name",
      //   render: (text) => <p>{text}</p>,
    },
    {
      title: "Vendor Email",
      dataIndex: "clientEmail",
      key: "clientEmail",
      render: (text) => (
        <a
          //   href={`mailto:${text}`}
          href={`https://outlook.office.com/mail/deeplink/compose?to=${text}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3699FF", textDecoration: "underline" }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "SPOC Email",
      dataIndex: "spocEmail",
      key: "spocEmail",
      render: (text) => (
        <a
          //   href={`mailto:${text}`}
          href={`https://outlook.office.com/mail/deeplink/compose?to=${text}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3699FF", textDecoration: "underline" }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "SPOC Mobile",
      dataIndex: "spocPhone",
      key: "vendorCompanyWebsiteUrl",
    },
    {
      title: "SPOC Person",
      key: "vendorCompanyWebsiteUrl",
      render: (record) => `${record.spocName} (${record.spocDesignation})`,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {(userData?.userRole == "company" ||
            userData?.permissions?.includes("client_details")) && (
            <Tooltip title="View Detail">
              <svg
                width="24"
                height="16"
                viewBox="0 0 30 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => handleClick(record)}
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.2818 0.0159601C7.45391 0.319947 1.70525 4.93397 0.109432 11.136C0.03645 11.4196 0 11.7099 0 12C0 12.2901 0.0364637 12.5804 0.109432 12.864C1.68348 18.9815 7.29798 23.554 14.0032 23.9692C14.3329 23.9896 14.6654 24 15 24C22.14 24 28.2391 19.2824 29.8906 12.864C29.9636 12.5804 30 12.2901 30 12C30 11.7099 29.9636 11.4196 29.8906 11.136C28.2391 4.71767 22.14 0 15 0C14.7593 0 14.5199 0.00536006 14.2818 0.0159601ZM21.8182 12C21.8182 15.6819 18.7657 18.6667 15 18.6667C11.2345 18.6667 8.18186 15.6819 8.18186 12C8.18186 8.31811 11.2345 5.33333 15 5.33333C18.7657 5.33333 21.8182 8.31811 21.8182 12ZM15 16C17.2594 16 19.0909 14.2092 19.0909 12C19.0909 9.7908 17.2594 8 15 8C12.7407 8 10.9091 9.7908 10.9091 12C10.9091 14.2092 12.7407 16 15 16Z"
                  fill="#13487D"
                />
              </svg>
            </Tooltip>
          )}
          {(userData?.userRole == "company" ||
            userData?.permissions?.includes("update_client")) && (
            <Tooltip placement="top" title="Edit">
              <svg
                width="20"
                height="20"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => handleEdit(record)}
              >
                <path
                  d="M16.625 13.608L11.6667 18.5663C11.2315 19.0003 10.6307 19.25 10.017 19.25H9.33333V18.5663C9.33333 17.9433 9.576 17.3577 10.017 16.9167L14.9753 11.9583L16.625 13.608ZM17.8418 9.09183L16.625 10.3087L18.2747 11.9583L19.4915 10.7415C19.9465 10.2865 19.9465 9.54683 19.4915 9.09183C19.0505 8.64967 18.2817 8.64967 17.8418 9.09183ZM28 5.83333V22.1667C28 25.3832 25.3832 28 22.1667 28H5.83333C2.61683 28 0 25.3832 0 22.1667V5.83333C0 2.61683 2.61683 0 5.83333 0H22.1667C25.3832 0 28 2.61683 28 5.83333ZM21.1423 7.44217C19.8193 6.12033 17.514 6.12033 16.1922 7.44217L8.36733 15.267C7.4865 16.1478 7 17.3203 7 18.5663V20.4167C7 21.0618 7.52267 21.5833 8.16667 21.5833H10.017C11.263 21.5833 12.4355 21.098 13.3163 20.216L21.1412 12.3912C22.5062 11.0262 22.5073 8.80717 21.1423 7.44217Z"
                  fill="#666666"
                />
              </svg>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 30,
    search: "",
  });

  const userData = useUserDetails();
  const userRole = localStorage.getItem("userRole");

  const handleClick = (record) => {
    setModalData(record);
    setVisible(true);
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      let results;

      if (userRole == "company") {
        results = await postReq("company/clients", tableParams);
      } else {
        results = await postReq("company/client-list", tableParams);
      }
      if (results.status === 200) {
        setData(results.data);
        setTotal(results.total);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      toastNotification("error", error.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      handleTagsData(true);
      fetchData();
    }, 300);

    return () => clearTimeout(timeout);
  }, [tableParams.search, tableParams.page, tableParams.limit]);
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      limit: pagination.pageSize,
    }));

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const handleCancle = () => {
    setVisible(false);
    setModalData({});
  };
  const handleOnChange = (e) => {
    setTableParams((prev) => ({ ...prev, search: e.target.value }));
  };

  const handleTagsData = async (isRequiredTech) => {
    try {
      let type = isRequiredTech ? "requiredTech" : "techNiche";

      const callResponse = await postReq("/common/getTags", {
        type: type,
      });

      if (callResponse.status == 1) {
        if (isRequiredTech) {
          setRequiredTech(callResponse.data.tags);
        } else {
          // setTechNicheOptions(callResponse.data);
        }
      }
    } catch (error) {
      console.log("error ", error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      let postData;
      if (editData) {
        postData = await postReq(
          `/company/update/client/${editData._id}`,
          values,
          {},
        );
      } else {
        postData = await postReq("/company/create/client", values, {});
      }
      if (postData.status == 200) {
        fetchData();
        form.resetFields();
        setShowModal(false);
        notification.success({
          message: "Success",
          description: `The Client ${
            editData ? "Updated" : "Created"
          } successful.`,
          placement: "topRight",
        });
      } else {
        form.resetFields();
        setShowModal(false);
        setEditData(null);
        notification.error({
          message: "Error",
          description:
            postData.message ||
            `There was an error ${editData ? "updating" : "creating"} Client.`,
          placement: "topRight",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description:
          error.message || "There was an error processing your request.",
        placement: "topRight",
      });
      form.resetFields();
      setShowModal(false);
    }
  };

  const handleEdit = (record) => {
    setShowModal(true);
    setEditData(record);
  };

  useEffect(() => {
    if (editData) {
      console.log(editData);
      form.setFieldsValue({
        // name: editData.name || "",
        clientCompanyName: editData.clientCompanyName || "",
        clientCompanyStrength: editData.clientCompanyStrength || "",
        clientCompanyWebsiteUrl: editData.clientCompanyWebsiteUrl || "",
        clientEmail: editData.clientEmail || "",
        requiredTech: editData.requiredTech.map((tech) => tech._id) || [],
        RegAddress: editData.RegAddress || "",
        spocName: editData.spocName || "",
        spocEmail: editData.spocEmail || "",
        spocPhone: editData.spocPhone || "",
        spocDesignation: editData.spocDesignation || "",
      });
    } else {
      form.resetFields(); // clears form when adding a new client
    }
  }, [editData, form]);
  return (
    <>
      {visible && (
        <Modal
          title="Client Details"
          open={visible}
          onCancel={handleCancle}
          width={900}
          bodyStyle={{ padding: "24px" }}
          headerStyle={{
            backgroundColor: "#F4F4F4",
          }}
          footer={null}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Descriptions bordered column={1} size="middle">
                {/* <Descriptions.Item label="Name">
                  {modalData.name}
                </Descriptions.Item> */}
                <Descriptions.Item label="Company Name">
                  {modalData.clientCompanyName}
                </Descriptions.Item>
                <Descriptions.Item label="Client Company Strength">
                  {modalData?.clientCompanyStrength || ""}
                </Descriptions.Item>
                <Descriptions.Item label="Client Company Website Url">
                  {modalData?.clientCompanyWebsiteUrl || ""}
                </Descriptions.Item>
                <Descriptions.Item label="Client Email">
                  {modalData?.clientEmail || ""}
                </Descriptions.Item>
                <Descriptions.Item label="Reg. Address">
                  {modalData?.RegAddress || ""}
                </Descriptions.Item>
                {/* <Descriptions.Item label="SPOC Name">
                  {modalData?.spocName || ""}
                </Descriptions.Item>
                <Descriptions.Item label="Company Pan NO">
                  {modalData?.vendorId?.ceoPanNo || ""}
                </Descriptions.Item> */}
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions bordered column={1} size="middle">
                <Descriptions.Item label="SPOC Name">
                  {modalData.spocName}
                </Descriptions.Item>
                <Descriptions.Item label="SPOC Designation">
                  {modalData.spocDesignation}
                </Descriptions.Item>
                <Descriptions.Item label="SPOC EMail">
                  {modalData?.spocEmail || ""}
                </Descriptions.Item>
                <Descriptions.Item label="SPOC Phone">
                  {modalData?.spocPhone || ""}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </Modal>
      )}
      <Modal
        title={`${editData ? "Update" : "Create"} Client`}
        open={showModal}
        onCancel={() => {
          setShowModal(false);
          setEditData(null);
        }}
        footer={
          <div style={{ paddingTop: "10px" }}>
            <Button
              type="default"
              // onClick={handleClear}
              style={{ marginRight: 8 }}
            >
              Reset
            </Button>
            <Button type="primary" onClick={() => form.submit()}>
              {`${editData ? "Update" : "Submit"}`}
            </Button>
          </div>
        }
        width="70%" // Full width on moblepx
        style={{ top: 0 }}
        bodyStyle={{ padding: 10 }}
        responsive={true}
        className="responsive-modal"
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Company Name"
                name="clientCompanyName"
                rules={[
                  {
                    required: true,
                    message: "Please enter Company name",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Company Strength"
                name="clientCompanyStrength"
                rules={[
                  {
                    required: true,
                    message: "Please enter company strength",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter Strength" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Company Website"
                name="clientCompanyWebsiteUrl"
                rules={[
                  {
                    required: true,
                    message: "Please enter Company name",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Company Email"
                name="clientEmail"
                rules={[
                  {
                    required: true,
                    message: "Please enter company Email",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter Strength" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Requirement Tech"
                name="requiredTech"
                rules={[
                  { required: true, message: "Please select requirement type" },
                ]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select"
                  className="ant-select-selection1"
                  allowClear
                  maxTagCount="responsive"
                >
                  {requiredTech.length > 0 &&
                    requiredTech.map((data, i) => (
                      <Option key={i} value={data._id}>
                        {data.value}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Form.Item
                label="Company Address."
                name="RegAddress"
                rules={[
                  {
                    required: true,
                    message: "Please enter Company Address.",
                  },
                  {
                    min: 100,
                    message: "Company Address must be at least 100 characters",
                  },
                  {
                    max: 500,
                    message: "Company Address cannot exceed 500 characters",
                  },
                ]}
              >
                <Input.TextArea
                  maxLength={500}
                  style={{ height: 100, resize: "vertical" }}
                  placeholder="Enter"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="SPOC Name"
                name="spocName"
                rules={[
                  {
                    required: true,
                    message: "Please enter SPOC Name",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter Strength" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="SPOC Email"
                name="spocEmail"
                rules={[
                  {
                    required: true,
                    message: "Please enter SPOC EMail",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter SPOC Email" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="SPOC Phone"
                name="spocPhone"
                rules={[
                  {
                    required: true,
                    message: "Please enter SPOC Phone",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter SPOC Phone Number" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="SPOC Designation"
                name="spocDesignation"
                rules={[
                  {
                    required: true,
                    message: "Please enter SPOC Designation",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter SPOC Designation" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderRadius: "20px 20px 0px 0px",
              margin: "0px -24px",
            }}
          >
            <div>
              <Title
                level={4}
                style={{
                  marginBottom: 0,
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#13487D",
                }}
              >
                Clients
              </Title>
            </div>

            <div style={{ display: "inline-flex", gap: "8px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F4F4F4",
                  borderRadius: "10px",
                  // padding: "10px 16px",
                  width: "300px",
                  boxShadow: "0px 1px 5px rgba(0,0,0,0.1)",
                }}
              >
                <Input
                  placeholder="Search By Client Name"
                  bordered={false}
                  onChange={handleOnChange}
                  style={{
                    fontSize: "16px",
                    color: "#6F6F6F",
                    border: "none",
                  }}
                />
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setIsSearch(!isSearch)}
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M35.2267 37.1801L40.6511 42.5978C41.1882 43.1342 42.0603 43.134 42.5974 42.5975C43.1343 42.0607 43.1342 41.1893 42.5971 40.6527L37.1763 35.2389C38.2668 33.757 38.9114 31.9269 38.9114 29.9476C38.9114 25.0092 34.8985 21 29.9557 21C25.0129 21 21 25.0092 21 29.9476C21 34.8859 25.0129 38.8951 29.9557 38.8951C31.9255 38.8951 33.7474 38.2586 35.2267 37.1801ZM29.9557 23.7501C33.3793 23.7501 36.159 26.5271 36.159 29.9476C36.159 33.3681 33.3793 36.1452 29.9557 36.1452C26.5321 36.1452 23.7526 33.3681 23.7526 29.9476C23.7526 26.5271 26.5321 23.7501 29.9557 23.7501Z"
                    fill="#13487D"
                  />
                </svg>
              </div>
              {/* )} */}
              {(userData?.userRole == "company" ||
                userData?.permissions?.includes("add_client")) && (
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setShowModal(true)}
                  style={{ cursor: "pointer" }}
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    d="M32 22V42"
                    stroke="#13487D"
                    stroke-width="2.7"
                    stroke-linecap="round"
                  />
                  <path
                    d="M42 32L22 32"
                    stroke="#13487D"
                    stroke-width="2.7"
                    stroke-linecap="round"
                  />
                </svg>
              )}
            </div>
          </div>
        }
        style={{
          paddingLeft: "16px",
          color: "#13487D",
          borderRadius: "18px",
          maxWidth: "100%",
          overflow: "hidden",
        }}
        bordered={false}
      >
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: tableParams.page,
            pageSize: tableParams.limit,
            total,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 30],
            // position: ["bottomCenter"],
            itemRender: (current, type, originalElement) => {
              if (type === "prev") {
                return <a>Prev</a>;
              }
              if (type === "next") {
                return <a>Next</a>;
              }
              return originalElement;
            },
            showTotal: (total, range) => (
              <span style={{ color: "#6b7280" }}>
                Showing {range[0]}–{range[1]} of {total}
              </span>
            ),
          }}
          loading={loading}
          scroll={{ x: "max-content" }}
          onChange={handleTableChange}
        />
      </Card>
    </>
  );
};

export default Client;
